import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=3d0d2359&scoped=true"
var script = {}
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=3d0d2359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d2359",
  null
  
)

export default component.exports